//WE.Flow.Html.Models.SysLogClientMessage
import { ClientLogLevel } from "./ClientLogLevel";

export class SysLogClientMessage {
    source: string = "";
    message: string = "";
    content: string = "";
    moduleId: string = "";
    logType: ClientLogLevel = null;
    moduleKeyName: string = "";
}
